import { WATCHLIST_WEBSOCKET_CONNECT_REQUEST, WATCHLIST_WEBSOCKET_CONNECTED, WATCHLIST_WEBSOCKET_CONNECT_ERR, WATCHLIST_WEBSOCKET_DISCONNECT_REQUEST, WATCHLIST_WEBSOCKET_DISCONNECTED, WATCHLIST_WEBSOCKET_DISCONNECT_ERR, WATCHLIST_WEBSOCKET_STATUS_REQUEST, WATCHLIST_WEBSOCKET_STATUS_COMPLETE, WATCHLIST_WEBSOCKET_STATUS_ERR, LIVE_PARTICIPANTS_REQUEST, LIVE_PARTICIPANTS_COMPLETE, LIVE_PARTICIPANTS_ERR, LIVE_PARTICIPANT_ADDRESSED_UPDATE_REQUEST, LIVE_PARTICIPANT_ADDRESSED_UDPATE_COMPLETE, LIVE_PARTICIPANT_ADDRESSED_UDPATE_ERR, SYNC_ZOOM_PARTICIPANTS_REQUEST, SYNC_ZOOM_PARTICIPANTS_COMPLETE, SYNC_ZOOM_PARTICIPANTS_ERR, WEBINAR_ID_SET, LIVE_PARTICIPANTS_RESET_ADDRESSED_REQUEST, LIVE_PARTICIPANTS_RESET_ADDRESSED_COMPLETE, LIVE_PARTICIPANTS_RESET_ADDRESSED_ERR } from '../actionTypes';
import * as watchlist from '../../api/zoomboard';
import errors from '../../config/errors';

export function connectWatchlistWebSocket(webinarId) {
  return async dispatch => {
    dispatch({ type: WATCHLIST_WEBSOCKET_CONNECT_REQUEST });
    try {
      let result = await watchlist.connectWatchlistWebSocket(webinarId);
      if (result.data.success) {
        dispatch({ type: WATCHLIST_WEBSOCKET_CONNECTED });      
      } else {
        dispatch({ type: WATCHLIST_WEBSOCKET_CONNECT_ERR, error: errors.RequestFailed });
      }
    } catch(error) {
      dispatch({ type: WATCHLIST_WEBSOCKET_CONNECT_ERR, error: errors.RequestFailed });
    }
  }
}

export function disconnectWatchlistWebSocket() {
  return async dispatch => {
    dispatch({ type: WATCHLIST_WEBSOCKET_DISCONNECT_REQUEST });
    try {
      let result = await watchlist.disconnectWatchlistWebSocket();
      if (result.data.success) {
        dispatch({ type: WATCHLIST_WEBSOCKET_DISCONNECTED });
      } else {
        dispatch({ type: WATCHLIST_WEBSOCKET_DISCONNECT_ERR, error: errors.RequestFailed });
      }
    } catch(error) {
      dispatch({ type: WATCHLIST_WEBSOCKET_DISCONNECT_ERR, error: errors.RequestFailed });
    }
  }
}

export function getWatchlistWebSocketStatus() {
  return async dispatch => {
    dispatch ({ type: WATCHLIST_WEBSOCKET_STATUS_REQUEST });
    try {
      let result = await watchlist.getWatchlistWebSocketStatus();
      dispatch({
        type: WATCHLIST_WEBSOCKET_STATUS_COMPLETE, 
        isConnected: result.data.isConnected,
        isReconnecting: result.data.isReconnecting, 
        webinarId: result.data.webinarId,
      });
    } catch(error) {
      dispatch({ type: WATCHLIST_WEBSOCKET_STATUS_ERR, error: errors.RequestFailed });
    }
  }
}

export function updateParticipantAddressed(memberId, addressed) {
  return async dispatch => {
    dispatch({ type: LIVE_PARTICIPANT_ADDRESSED_UPDATE_REQUEST, memberId });
    try {
      const result = await watchlist.updateParticipantAddressed(memberId, addressed);
      dispatch({ type: LIVE_PARTICIPANT_ADDRESSED_UDPATE_COMPLETE, memberId, addressed: result.data.addressed })
    } catch (error) {
      dispatch({ type: LIVE_PARTICIPANT_ADDRESSED_UDPATE_ERR, memberId, error: errors.RequestFailed })
    }
  }
}

export function getLiveParticipants() {
  return async dispatch => {
    dispatch({ type: LIVE_PARTICIPANTS_REQUEST });
    try {
      let result = await watchlist.getLiveParticipants();
      dispatch({ type: LIVE_PARTICIPANTS_COMPLETE, data: result.data.participants });
    } catch(error) {
      dispatch({ type: LIVE_PARTICIPANTS_ERR, error: errors.RequestFailed });
    }
  }
}

export function syncZoomParticipants(webinarId) {
  return async dispatch => {
    dispatch({ type: SYNC_ZOOM_PARTICIPANTS_REQUEST });
    try {
      let result = await watchlist.syncZoomParticipants(webinarId);
      if (result.data.success) {
        dispatch({ type: SYNC_ZOOM_PARTICIPANTS_COMPLETE, data: result.data.participants });
      } else {
        dispatch({ type: SYNC_ZOOM_PARTICIPANTS_ERR, error: errors.RequestFailed });
      }
    } catch (error) {
      dispatch({ type: SYNC_ZOOM_PARTICIPANTS_ERR, error: errors.RequestFailed});
    }
  }
}

export function resetAddressedParticipants() {
  return async dispatch => {
    dispatch({ type: LIVE_PARTICIPANTS_RESET_ADDRESSED_REQUEST });
    try {
      const result = await watchlist.resetAddressedParticipants();
      if (result.data.success) {
        dispatch({ type: LIVE_PARTICIPANTS_RESET_ADDRESSED_COMPLETE });
      } else {
        dispatch({ type: LIVE_PARTICIPANTS_RESET_ADDRESSED_ERR, error: errors.RequestFailed });
      }
    } catch (error) {
      dispatch({ type: LIVE_PARTICIPANTS_RESET_ADDRESSED_ERR, error: errors.RequestFailed });
    }
  }
}

export function setWebinarId(webinarId) {
  return { type: WEBINAR_ID_SET, webinarId };
}